import { render, staticRenderFns } from "./EditSalonItem.vue?vue&type=template&id=14bbce02&scoped=true"
import script from "./EditSalonItem.vue?vue&type=script&lang=js"
export * from "./EditSalonItem.vue?vue&type=script&lang=js"
import style0 from "./EditSalonItem.vue?vue&type=style&index=0&id=14bbce02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bbce02",
  null
  
)

export default component.exports